import React, { useState } from 'react';
import { Button } from 'react-bootstrap5';
import { useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function BuildAiProgram() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const buildAiProgram = () => {
    setLoading(true);
    navigate(routes.members.programs.new_ai.index);
  };

  return (

    <Button
      onClick={() => buildAiProgram()}
      disabled={loading}
      className="mt-3 mt-md-0"
    >
      {loading && <LoadingPlaceholder placement="inline" text=" " />}
      Build AI Program
    </Button>
  );
}
